import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

/* eslint-disable max-len */
// const logoQS = (
//   <StaticImage src="../../images/video-stand/QuickStart.svg" alt="" objectFit="contain" className="image imageActive" />
// )
// const logoQSLight = (
//   <StaticImage src="../../images/video-stand/QuickStart-light.svg" alt="" objectFit="contain" className="image" />
// )

const logoFS = (
  <StaticImage src="../../images/video-stand/Fusion.svg" alt="" objectFit="contain" className="image imageActive" />
)
const logoFSLight = (
  <StaticImage src="../../images/video-stand/Fusion-light.svg" alt="" objectFit="contain" className="image" />
)

const logoFM = (
  <StaticImage src="../../images/video-stand/freshMS.svg" alt="" objectFit="contain" className="image imageActive" />
)
const logoFMLight = (
  <StaticImage src="../../images/video-stand/freshMS-light.svg" alt="" objectFit="contain" className="image" />
)

const logoTSBO = (
  <StaticImage src="../../images/video-stand/TSBO.svg" alt="" objectFit="contain" className="image imageActive" />
)
const logoTSBOLight = (
  <StaticImage src="../../images/video-stand/TSBO-light.svg" alt="" objectFit="contain" className="image" />
)
/* eslint-enable max-len */

const TS_VIDEO_ID = '5EjskqE1drg'
const QS_VIDEO_ID = 'pC40d9P_eyo'
const FS_VIDEO_ID = 'l9qS0VKTYhc'
const FM_VIDEO_ID = 'fSpR6ZAc1OA'

export const VIDEO_LIST = [
  {
    id: TS_VIDEO_ID,
    type: 'yt',
    name: 'Where it all comes together',
    imgActive: logoTSBO,
    img: logoTSBOLight
  },
  {
    id: QS_VIDEO_ID,
    type: 'yt',
    name: 'Your eCommerce Platform',
    imgActive: logoTSBO,
    img: logoTSBOLight
  },
  {
    id: FS_VIDEO_ID,
    type: 'yt',
    code: 'fusion',
    name: 'Product-Source Connector',
    imgActive: logoFS,
    img: logoFSLight
  },
  {
    id: FM_VIDEO_ID,
    type: 'yt',
    name: 'Marketing Management System',
    imgActive: logoFM,
    img: logoFMLight
  },
]

export const VIDEO_LIST_ORDER = [TS_VIDEO_ID, QS_VIDEO_ID, FS_VIDEO_ID, FM_VIDEO_ID]

export const PLAYER_OPTIONS = {
  height: '2160',
  width: '3840',
  playerVars: {
    controls: 1,
    fs: 0,
    autoplay: 0,
    mute: 1,
    enablejsapi: 1,
    rel: 0,
    disablekb: 1,
    modestbranding: 1,
    showinfo: 0
  }
}
